import { useState, useEffect, useMemo } from 'react'

export const useFetchEntities = (queries = [], deps = []) => {
  const [data, setData] = useState({})
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(true)

  const queriesJSON = useMemo(() => JSON.stringify(queries), [queries])

  useEffect(() => {
    let cancelled = false

    const run = async () => {
      setLoading(true)
      setError(null)
      try {
        const results = await Promise.allSettled(queries.map(({ fn, args = [] }) => fn(...args)))
        const mappedData = {}
        let someError = false

        results.forEach((res, index) => {
          const key = queries[index].key
          if (res.status === 'fulfilled') {
            mappedData[key] = res.value?.data
          } else {
            someError = true
            mappedData[key] = null
          }
        })

        if (!cancelled) {
          setData(mappedData)
          if (someError) setError(new Error('Some queries failed'))
        }
      } catch (e) {
        if (!cancelled) setError(e)
      } finally {
        if (!cancelled) setLoading(false)
      }
    }

    run()

    return () => {
      cancelled = true
    }
  }, [queriesJSON, ...deps]) // eslint-ignore react-hooks/exhaustive-deps for deps spread

  return { data, loading, error }
}
